import {HoistService, XH} from '@xh/hoist/core';
import {getDefaultOptions} from '../../core/ServiceUtils';
import {NewsItem} from '../data/DataTypes';

export class NewsService extends HoistService {
    async fetchNewsAsync(fetchOpts = getDefaultOptions()): Promise<NewsItem[]> {
        return XH.fetchService.fetchJson({
            url: `${XH.getConf('svcApiUrl')}/news`,
            params: {count: 10},
            method: 'GET',
            ...fetchOpts
        });
    }
}
